// EGGS Design System Components

// Phase 1 Components (Foundation)
export { default as Button } from './Button';
export { default as Text, H1, H2, H3, H4, H5, H6, Body, Caption, Heading } from './Text';
export { default as Icon } from './Icon';

// Phase 2 Components (Forms & Layout)
// Form Components
export { default as Input, SearchInput, PasswordInput, EmailInput } from './Input';
export { default as Textarea } from './Textarea';
export { default as Select } from './Select';
export { default as Checkbox } from './Checkbox';
export { default as Radio, RadioGroup } from './Radio';

// Social/OAuth Components
export { default as SocialButton, MicrosoftButton, LinkedInButton, AppleButton, GoogleButton } from './SocialButton';

// Layout Components
export { default as Card, SpeakerCard, SessionCard, ElevatedCard, OutlinedCard } from './Card';
export { default as Container, SmallContainer, MediumContainer, LargeContainer, ExtraLargeContainer, FullContainer } from './Container';
export { default as Section, PrimarySection, SecondarySection, DarkSection, LightSection, HeroSection } from './Section';

// Feedback Components
export { default as Alert, SuccessAlert, ErrorAlert, WarningAlert, InfoAlert } from './Alert';
export { default as Modal, ConfirmModal, AlertModal } from './Modal';
export { default as ErrorFallback } from './ErrorFallback';

// Page Components
export { default as WelcomeScreen } from './WelcomeScreen';

// Development/Testing
export { default as DesignSystemTest } from './DesignSystemTest';

// Booking Components
export { default as GondolaCard } from './GondolaCard';
export { default as OnboardingBanner } from './OnboardingBanner';
export { default as SmartPicture } from './SmartPicture';
export { default as QRCode } from './QRCode';
export { default as StatusBadge, STATUS_MAP } from './StatusBadge';
